import {override} from 'mobx';
import {AutoAnimation} from "../../../../../infrastructure/models/animation/auto-animation";
import {MatchEndedAnimationSetModel} from "../../../../../infrastructure/models/animation/game/animation-set-models/goal/match-ended-animation-set-model";
import {ANIMATION_TIMES} from "../../../../../core/consts";

export class GameCenterHeaderMatchEndedAnimationSetModel extends MatchEndedAnimationSetModel {
  duration: Number;

  constructor(animation) {
    super(animation);

    this.duration = ANIMATION_TIMES.GAME_CENTER.generalAnimationTime;
  }

  @override get statusContainer(): AutoAnimation {
    const enterAnimation: String = 'fade-in';
    const mainAnimation: String = 'scale-up-center-infinite';
    const leaveAnimation: String = 'scale-up-center-infinite'

    const container = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      this.durationByRatio(0.9), this.durationByRatio(0.05), this.durationByRatio(0.05));

    return container;
  }
}
